module.exports = __webpack_public_path__ + "img/writing3.c55f98e.jpg";